import isNil from 'lodash-es/isNil';
import moment from 'moment-timezone';
import { useClient } from '../../../ClientProvider';
import useQuery from '../../../useQuery';
export const useDecitraitTreatments = ({ plotId }) => {
    const client = useClient();
    const year = moment().year();
    const plot = useQuery(client.plots.get(plotId)).data;
    const organizationId = plot?.organizationId;
    const treatmentsRequest = useQuery(client.decitrait.treatmentsPerYear({ plotId: plotId, year, organizationId }), {
        enabled: !isNil(organizationId)
    });
    const treatments = treatmentsRequest.data;
    const onDeleteTreatmentSuccess = () => treatmentsRequest.refetch();
    return { plot, treatments, organizationId, onDeleteTreatmentSuccess };
};
